import { defaultSiteContextMode } from '@/lib/config.shared'
import { getTenantMarkets } from '@/lib/tenant/getTenantMarkets'

import type { TenantConfig } from '@/config/tenants/types'
import type { SiteContextModeEnum } from '@/enums/SiteContextModeEnum'

export type SiteContextTenant = Pick<TenantConfig, 'id' | 'marketSanity'>

export const getTenantDefaultSiteContext = (tenant: SiteContextTenant): SiteContextModeEnum => {
  const validSites = getTenantMarkets(tenant.id)
  const defaultMarket = tenant.marketSanity?.[0]

  return validSites.find((site) => defaultMarket?.includes(site)) ?? validSites[0] ?? defaultSiteContextMode
}

export const resolveSiteContext = (
  tenant: SiteContextTenant,
  requested?: string | null,
  fallback?: string | null
): SiteContextModeEnum => {
  const validSites = getTenantMarkets(tenant.id)

  return (
    validSites.find((site) => site === requested) ??
    validSites.find((site) => site === fallback) ??
    getTenantDefaultSiteContext(tenant)
  )
}
